// extracted by mini-css-extract-plugin
module.exports = {"root":"DateExcess_root__1NB8h"};